import {pullRequestsAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {ChangesRoutePayload} from './route-payload-types'

export const pullRequestsChangesRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsChangesRoute', {
  path: '/:owner/:repo/pull/:pr_number/changes',
  queries: [mainQuery<ChangesRoutePayload>()],
})

export const pullRequestsChangesWithRangeRoute = pullRequestsAppBuilder.createQueryRouteConfig(
  'pullRequestsChangesWithRangeRoute',
  {
    path: '/:owner/:repo/pull/:pr_number/changes/:range',
    queries: [mainQuery<ChangesRoutePayload>()],
  },
)
